/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react'
import userService from '../../../../../Services/userService'
import { Loader } from '../../../../../Components'
import { useDropzone } from 'react-dropzone'
import './DocumentTab.scss'
import { toast } from 'react-hot-toast'
import { Modal } from 'react-bootstrap'
// import { useNavigate } from 'react-router-dom'
interface dataTypes {
  register: any,
  errors: any,
  handleChange: (Value: any) => void,
  values: any,
  refid: any
}
const documentsMapper = (type: string) => {
  switch (type) {
    // case 'waec':
    //   return 'WAEC';
    // case 'gce':
    //   // code block
    //   return 'GCE'
    // case 'neco':
    //   // code block
    //   return 'Neco';
    // case 'nabteb':
    //   // code block
    //   return 'NABTEB';
    // case 'waec1':
    //   return 'WAEC1';
    // case 'gce1':
    //   // code block
    //   return 'GCE1'
    // case 'neco1':
    //   // code block
    //   return 'Neco1';
    // case 'nabteb1':
    //   // code block
    //   return 'NABTEB1';
    case 'ssce':
      // code block
      return 'SSCE'
    case 'ssce2':
      // code block
      return 'SSCE2'
    case 'birthCertificate':
      // code block
      return 'Birth Certificate/Age Declaration'
    case 'indigneCerificate':
      // code block
      return 'LGA/ indigene certificate '
    default:
    // code block
  }
}
type DocumentsType = {
  // waec: File | string;
  // waec2: any;
  // gce: File | string;
  // gce2: any;
  // neco: File | string;
  // neco2: any;
  // nabteb: File | string;
  // nabteb2: any;
  ssce: File | string;
  ssce2: File | string;
  birthCertificate: File | string;
  indigneCerificate: File | string;
}
const emptyDocuments = {
  // waec: '',
  // gce: '',
  // neco: '',
  // nabteb: '',
  // waec1: '',
  // gce1: '',
  // neco1: '',
  // nabteb1: '',
  ssce: '',
  ssce2: '',
  birthCertificate: '',
  indigneCerificate: ''
}
const DocumentTab: React.FC<dataTypes> = ({ register, errors, handleChange, refid }) => {
  const [loader, setLoader] = useState(false)
  const [values, setValues] = useState<any>([])
  // eslint-disable-next-line no-unused-vars
  const [documents, setDocuments] = useState<DocumentsType | any>(emptyDocuments)
  const [images, setImages] = useState()
  const [photos, setPhotos] = useState()
  // eslint-disable-next-line no-unused-vars
  const [sittings, setSittings] = useState<number>(0)
  const [ssimages, setSSimages] = useState()
  const [indDoc, setIndDoc] = useState()
  const [birthCertDoc, setBirthCertDoc] = useState()
  const [currentDocument, setCurrentDocument] = useState<string | any>('')
  const [documentError, setDocumentError] = useState<any>()
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [selectFile, setSelectFile] = useState(null)
  const [show, setShow] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [sumit, setSumit] = useState<boolean>(false)
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    // accept: 'image/*',
    onDrop: (acceptedFiles: any[]) => {
      const file = acceptedFiles[0]
      if (file) {
        setSelectedFile(file)
      }
    }
  })
  const getData = async () => {
    // setLoader(true)
    try {
      await userService.getImagesList(refid).then((res: any) => {
        // console.log('DANGER GGDDGGDGGSSS', res.data.data)
        setLoader(false)
        // const usk = Object.values(res.data.data)
        setValues(res.data.data)
        // console.log('hey', { usk })
        // console.log('wahhh', { ...res.data.data })
        // dispatcher({ type: APPLICANT_SUCCESS, payload: { ...res.data.dataset.nimc, ...res.data.dataset.jamb.dataset, ...res.data.metadata, photo: res.data.photo, workflow: res.data.dataset.workflow } })
      }, (error: any) => {
        setLoader(false)
        // navigate('/applicants', { replace: true })
        console.log('DANGER ERROR', error)
        // toast.error(error.response.data.message, { duration: 20000, className: 'bg-danger text-white' })
      })
    } catch (error: any) {
      setLoader(false)
      //   navigate('/applicants', { replace: true })
      console.log('DANGER ERROR', error)
      //   toast.error(error.response?.data?.message, { duration: 20000, className: 'bg-danger text-white' })
    }
  }
  useEffect(() => {
    getData()
  }, [])

  const birth = values?.find((doc: any) => doc?.toLowerCase().includes('birth'))
  const indig = values?.find((doc: any) => doc?.toLowerCase().includes('indig'))
  const photo: any = values?.find((doc: any) => doc?.toLowerCase().includes('passport'))
  const ssce = values?.find((doc: any) => doc?.toLowerCase().includes('ssce'))
  const getPhoto = async () => {
    // setLoader(true)
    try {
      await userService.getImages(photo, refid).then((res: any) => {
        setLoader(false)
        setPhotos(res.data)
      }, (error: any) => {
        setLoader(false)
        console.log('DANGER ERROR', error)
        // toast.error(error.response.data.message, { duration: 20000, className: 'bg-danger text-white' })
      })
    } catch (error: any) {
      setLoader(false)
      // navigate('/applicants', { replace: true })
      console.log('DANGER ERROR', error)
      //   toast.error(error.response?.data?.message, { duration: 20000, className: 'bg-danger text-white' })
    }
  }
  useEffect(() => {
    const timingOuts = setTimeout(() => {
      getPhoto()
    }, 200)
    return () => {
      clearTimeout(timingOuts)
    }
  })
  const getSSCEDoc = async () => {
    // setLoader(true)
    try {
      await userService.getImagesSS(ssce, refid).then((res: any) => {
        setLoader(false)
        setSSimages(res.data)
      }, (error: any) => {
        setLoader(false)
        console.log('DANGER ERROR', error)
      })
    } catch (error: any) {
      setLoader(false)
      //   navigate('/applicants', { replace: true })
      console.log('DANGER ERROR', error)
      //   toast.error(error.response?.data?.message, { duration: 20000, className: 'bg-danger text-white' })
    }
  }
  useEffect(() => {
    const timingOut = setTimeout(() => {
      getSSCEDoc()
    }, 200)
    return () => {
      clearTimeout(timingOut)
    }
  })
  const getIndigineDoc = async () => {
    // setLoader(true)
    try {
      await userService.getIndigine(indig, refid).then((res: any) => {
        setLoader(false)
        // const usk = Object.values(res.data.data)
        setIndDoc(res.data)
      }, (error: any) => {
        setLoader(false)
        console.log('DANGER ERROR', error)
        // toast.error(error.response.data.message, { duration: 20000, className: 'bg-danger text-white' })
      })
    } catch (error: any) {
      setLoader(false)
    }
  }
  useEffect(() => {
    const timingOut = setTimeout(() => {
      getIndigineDoc()
    }, 200)
    return () => {
      clearTimeout(timingOut)
    }
  })

  const getBirthCertDoc = async () => {
    // setLoader(true)
    try {
      await userService.getbirthCert(birth, refid).then((res: any) => {
        // console.log('BIRTH GGDDGGDGGSSSSSSS', res.data)
        // console.log('BirthTest', birthCertDoc)
        setLoader(false)
        // const usk = Object.values(res.data.data)
        setBirthCertDoc(res.data)
        // console.log('hey', { usk })
        // console.log('wahhhsjczclcjzcjkckjzj', res.data.data)
        // dispatcher({ type: APPLICANT_SUCCESS, payload: { ...res.data.dataset.nimc, ...res.data.dataset.jamb.dataset, ...res.data.metadata, photo: res.data.photo, workflow: res.data.dataset.workflow } })
      }, (error: any) => {
        setLoader(false)
        // navigate('/applicants', { replace: true })
        console.log('DANGER ERROR', error)
        // toast.error(error.response.data.message, { duration: 20000, className: 'bg-danger text-white' })
      })
    } catch (error: any) {
      setLoader(false)
      //   navigate('/applicants', { replace: true })
      console.log('DANGER ERROR', error)
      //   toast.error(error.response?.data?.message, { duration: 20000, className: 'bg-danger text-white' })
    }
  }
  useEffect(() => {
    const timingOut = setTimeout(() => {
      getBirthCertDoc()
    }, 200)
    return () => {
      clearTimeout(timingOut)
    }
  })
  console.log('images', photo)
  const removeDocument = useCallback((type: any) => {
    setDocuments({
      ...documents,
      [type]: ''
    })
  }, [setDocuments, documents])
  const changeCurrentDocument = (e: any) => {
    const foh = e.target.value
    setCurrentDocument(foh)

    setDocumentError(null)
  }

  const throwError = (mess: string = 'There was an error submitting application!') => {
    toast.error(mess)
  }
  const Uploader = async () => {
    if (!selectedFile || !currentDocument) {
      toast.error('Please select a file and document type')
      return
    }

    const formData = new FormData()
    formData.append('document', selectedFile)
    formData.append('nin', refid)
    formData.append('documentType', currentDocument)
    formData.append('workFlow', 'formSubmission')
    // console.log('FormData entries: ', Array.from(formData.entries()))
    try {
      await userService.uploadDocument(formData).then((res) => {
        toast.success('Document Uploaded Successfully')
        setSelectedFile(null)
        getData()
      })
    } catch (error) {
      console.log(error)
      throwError()
    }
  }
  const handleCliked = (e: any) => {
    e.preventDefault()
    Uploader()
  }
  const handleImage = (photos: any) => {
    getPhoto()
    setSelectFile(photos)
    setShow(true)
  }
  const handleBirth = (birthCertDoc: any) => {
    getBirthCertDoc()
    setSelectFile(birthCertDoc)
    setShow(true)
  }
  const handleInd = (indDoc: any) => {
    getIndigineDoc()
    setSelectFile(indDoc)
    setShow(true)
  }
  const handleSsce = (ssimages: any) => {
    getSSCEDoc()
    setSelectFile(ssimages)
    setShow(true)
  }
  // useEffect(() => {
  //   Uploader()
  // })
  const dashroute = localStorage.getItem('__userRole')
  const isOfficer = dashroute === 'pscreen_officer'

  // const openModal = () => {
  //   setSelectFile()
  //   setShow(true)
  // }

  const closeModal = () => {
    setSelectFile(null)
    setShow(false)
  }
  return (
    <div className='document-tab-modern'>
      <div className='form-card'>
        <div className='form-card-header'>
          <div className='header-icon'>
            <i className='fa fa-folder-open'></i>
          </div>
          <h3 className='header-title'>Uploaded Documents</h3>
        </div>
        <div className='form-card-body'>
          <div className='documents-grid'>
            <div className='document-item'>
              <div className='document-info'>
                <i className='fa fa-camera document-icon'></i>
                <span className='document-name'>Photo</span>
              </div>
              <button className='view-button' type='button' onClick={() => handleImage(photos)}>
                <i className='fa fa-eye'></i>
                View
              </button>
            </div>
            <div className='document-item'>
              <div className='document-info'>
                <i className='fa fa-graduation-cap document-icon'></i>
                <span className='document-name'>SSCE Certificate</span>
              </div>
              <button className='view-button' type='button' onClick={() => handleSsce(ssimages)}>
                <i className='fa fa-eye'></i>
                View
              </button>
            </div>
            <div className='document-item'>
              <div className='document-info'>
                <i className='fa fa-file-text document-icon'></i>
                <span className='document-name'>LGA Document</span>
              </div>
              <button className='view-button' type='button' onClick={() => handleInd(indDoc)}>
                <i className='fa fa-eye'></i>
                View
              </button>
            </div>
            <div className='document-item'>
              <div className='document-info'>
                <i className='fa fa-certificate document-icon'></i>
                <span className='document-name'>Birth Certificate</span>
              </div>
              <button className='view-button' type='button' onClick={() => handleBirth(birthCertDoc)}>
                <i className='fa fa-eye'></i>
                View
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={closeModal}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Document Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-0">
          {selectFile !== undefined && selectFile !== null
            ? (
                <div style={{ height: '80vh', overflow: 'auto' }}>
                  <img
                    src={selectFile || ''}
                    alt="Document"
                    style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                  />
                </div>
              )
            : (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
        </Modal.Body>
      </Modal>

      {!isOfficer &&
        <div className='form-card upload-section'>
          <div className='form-card-header'>
            <div className='header-icon'>
              <i className='fa fa-cloud-upload'></i>
            </div>
            <h3 className='header-title'>Document Upload</h3>
          </div>
          <div className='form-card-body'>
            <form>
              <div className='upload-container'>
                <div className='upload-notice'>
                  <i className='fa fa-info-circle'></i>
                  <span>NB: Maximum of two(2) OLevel sittings are allowed. Ensure you upload a well scanned document. A poorly scanned document with low resolution is not verifiable.</span>
                </div>

                <div className='form-field'>
                  <label style={{ fontSize: '1.1rem', fontWeight: '500', marginBottom: '0.75rem' }}>
                    Choose a document type to upload (.jpg only) <span className='text-danger'>*</span>
                  </label>
                  <select
                    className='form-control form-control-lg'
                    style={{ fontSize: '1.1rem', padding: '0.25rem 1rem' }}
                    value={currentDocument}
                    onChange={changeCurrentDocument}
                  >
                    <option value=''> -- choose file type to upload -- </option>
                    <optgroup label='Required Documents'>
                      <option value='birthCertificate'>Birth Certificate/Age Declaration</option>
                      <option value='lgaCerificate'>LGA certificate</option>
                    </optgroup>
                    <optgroup label='SSCE Certificate'>
                      <option value='waec'>WAEC</option>
                      <option value='gce'>GCE</option>
                      <option value='neco'>NECO</option>
                    </optgroup>
                  </select>
                  {documentError && <small className='error-message'>{documentError}</small>}
                </div>

                {currentDocument && (
                  <div className='dropzone-wrapper' {...getRootProps()}>
                    <input type='file' accept='image/*' {...getInputProps()} />
                    <div className='dropzone-content'>
                      {isDragActive
                        ? (
                        <>
                          <i className='fa fa-download dropzone-icon'></i>
                          <h4>Drop the file here</h4>
                        </>
                          )
                        : (
                        <>
                          <i className='fa fa-cloud-upload dropzone-icon'></i>
                          <h4>Click here to upload a file</h4>
                          <p>or Drag and drop a file</p>
                        </>
                          )}
                    </div>
                  </div>
                )}

                {selectedFile?.name && (
                  <div className='file-info'>
                    <i className='fa fa-file-image-o'></i>
                    <span>{selectedFile?.name}</span>
                  </div>
                )}
                <div className='uploaded-tags'>
                  {Object.keys(documents).map((key: string, index: number) => {
                    if (documents[key as keyof DocumentsType] !== '') {
                      return (
                        <span key={index} className='document-tag'>
                          {documentsMapper(key)}
                          <button onClick={() => removeDocument(key)} className='remove-tag'>
                            <i className='fa fa-times'></i>
                          </button>
                        </span>
                      )
                    }
                    return null
                  })}
                </div>

                <button
                  className='upload-button'
                  type='button'
                  onClick={handleCliked}
                  disabled={sumit}
                >
                  {sumit
                    ? (
                    <>
                      <span className='spinner-border spinner-border-sm me-2'></span>
                      Uploading...
                    </>
                      )
                    : (
                    <>
                      <i className='fa fa-upload me-2'></i>
                      Upload Document
                    </>
                      )}
                </button>
              </div>
            </form>
          </div>
        </div>
      }
      <Loader show={loader}></Loader>
    </div>
  )
}

export default DocumentTab
